exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-65dfc563] {\n  width: 100%;\n}\n.valid-message[data-v-65dfc563] {\n    padding-top: 15px;\n}\n", ""]);

// exports
